module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/trapezeartist.0fd66e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/trapezeartist.jpg
// module id = nhlr
// module chunks = 0